module.exports = __webpack_public_path__ + "static/img/linepoint@2x.3229bb92.png";